export default {"src":"/_next/static/media/kitchen.6ddd8c02.svg","height":100,"width":100};